<template lang="pug">
.shopPage

  linked-tabs.tabs
    linked-tabs-item(:to="localePath('market-index-shop-index-heroes')" :is-active="$route.name.includes('heroes')")
      span {{$t('market.tabs.gachaMint')}}
    //- linked-tabs-item(:to="localePath('market-index-shop-index-prime')" :is-active="$route.name.includes('prime')")
    //-   span {{$t('market.tabs.prime')}}
    //- linked-tabs-item(:to="localePath('market-index-shop-index-labo')" :is-active="$route.name.includes('labo')")
    //-   span {{$t('market.tabs.labo')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-landvolumeshop')" :is-active="$route.name.includes('landvolumeshop')")
      span {{$t('market.tabs.landVolumeShop')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-trade')" :is-active="$route.name.includes('trade')")
      span {{$t('market.tabs.trade')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-exchange')" :is-active="$route.name.includes('exchange')")
      span {{$t('market.tabs.exchange')}}
    linked-tabs-item(
      :to="localePath('market-index-shop-index-ppdshop-index-sale')"
      :is-active="$route.name.includes('ppdshop')"
      class="highlight"
    )
      span {{$t('market.tabs.ppd')}}
      //- div(:style="{ backgroundImage: `url('${$env.cdnUrl}/rsc/item/consume_item/item_50005.png')` }" class="jumping-icon")
      span(class="sale-text") SALE

  //- .shopPage__links
    ul
      li
        nuxt-link(:to="localePath('market-index-shop-index-heroes')") Heroes
      li
        nuxt-link(:to="localePath('market-index-shop-index-prime')") {{ $t('pages.prime') }}
      li
        nuxt-link(:to="localePath('market-index-shop-index-rep-heroes')") Rep. Heroes

  nuxt-child

  Tokusho(v-if="!$route.name.includes('ppdshop')")

</template>

<script>
const Tokusho = () => import('@/components/atoms/Tokusho')
const LinkedTabs = () => import('@/components/organisms/LinkedTabs')
const LinkedTabsItem = () => import('@/components/molecules/LinkedTabsItem')

export default {
  components: {
    LinkedTabs,
    LinkedTabsItem,
    Tokusho,
  },
  fetch({ route, redirect }) {
    let routeName = String(route.name)
    if (
      (routeName.includes('heroes') ||
        routeName.includes('prime') ||
        routeName.includes('labo') ||
        routeName.includes('trade') ||
        routeName.includes('exchange') ||
        routeName.includes('landvolumeshop') ||
        routeName.includes('ppdshop')) == false
    )
      return redirect('/market/shop/heroes')
  },
}
</script>

<style lang="scss" scoped>
.shopPage {
  &__links {
    ul {
      display: flex;
      justify-content: space-around;
      list-style-type: none;
      margin: 1rem auto;
      max-width: 640px;
      padding: 0;

      @media (min-width: $breakpoint) {
        margin: 2rem auto;
      }
    }

    li {
      flex: 1;

      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4) {
        margin-left: 1rem;

        @media (min-width: $breakpoint) {
          margin-left: 2rem;
        }
      }
    }

    a {
      align-items: center;
      border: 1px solid;
      border-radius: 1rem;
      color: #ccc;
      display: flex;
      font-size: 0.75rem;
      height: 100%;
      justify-content: center;
      line-height: 1;
      padding: 0.5rem;
      text-align: center;
      text-decoration: none;

      @media (min-width: $breakpoint) {
        font-size: 1rem;
        padding: 1rem;
      }

      &.nuxt-link-active {
        border: 2px solid;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}

.highlight {
  position: relative;
}

.jumping-indicator {
  margin-top: .5rem;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -5px;
  animation: jump 1s infinite;
}

.sale-badge {
  margin-top: .5rem;
  color: white;
  background-color: red;
  padding: 0.2rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: bold;
}

.jumping-icon {
  width: 20px;
  height: 20px;
  background-size: cover;
  position: absolute;
  top: -10px;
  right: -10px;
  animation: jump-scale 1.5s infinite;
}

.sale-text {
  position: absolute;
  top: -10px;
  right: -10px;
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
  background-color: red;
  padding: 0.2rem 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

.sale-text::after {
  content: '';
  position: absolute;
  bottom: -5px;
  right: 10px;
  width: 0;
  height: 0;
  border-width: 5px;
  border-style: solid;
  border-color: red transparent transparent transparent;
}

@keyframes jump {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes jump-scale {
  0%, 100% {
    transform: scale(1) translateY(0);
  }
  50% {
    transform: scale(1.2) translateY(-10px);
  }
}

@keyframes fade-in-out {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
